import * as React from "react";
import PrimaryButton from "../../app/Common/Buttons/PrimaryButton";
import PopupManager from "../../app/Common/Popups/PopupManager";
import { LoginNews } from "../../app/Routes/Login/News/LoginNews";
import FontAwesomeLight from "../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";
import Request, { getCookie } from "../../app/Utilities/Platform/Request";
import LoginForm from "./LoginForm";

type State = {
    store: string;
    username: string;
    password: string;
    loadingLogin: boolean;
    showStore: boolean;
};

export default class LoginBox extends React.Component<unknown, State> {
    public state: State = {
        store       : "",
        username    : "",
        password    : "",
        loadingLogin: false,
        showStore   : true,
    };

    public componentDidMount(): void {
        this.checkStoreURL();
    }

    public handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            password: e.currentTarget.value,
        });
    };

    public handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            username: e.currentTarget.value,
        });
    };

    public handleStoreChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            store: e.currentTarget.value,
        });
    };

    public handleLogin = (): void => {
        if(!this.state.password) {
            PopupManager.error("Please enter a password.");

            return;
        }

        this.setState({
            loadingLogin: true,
        });

        Request.post("/login", {
            storeurl: this.state.store,
            username: this.state.username,
            password: this.state.password,
            global  : true,
            intended: new URL(window.location.href).searchParams.get("intended"),
        }, {
            headers: {
                "Accept": "application/json",
            },
            timeout: 7000,
        })
            .then(response => {
                if(response.data.redirect) {
                    // Redirect to correct location
                    window.location.replace(response.data.redirect);
                } else {
                    window.location.href = "/";
                }
            })
            .catch(async err => {
                if(err.code === "ECONNABORTED") {
                    PopupManager.info("Login timed out, please try again");

                    return;
                }

                if(
                    !err.response ||
                    err.response.status === 0 ||
                    err.response.status === 540 ||
                    err.response.status === 541
                ) {
                    PopupManager.error("Unable to send login request. Please try again.");

                    return;
                }

                PopupManager.error("Invalid login details. Please try again.");
            })
            .finally(() => {
                this.setState({
                    loadingLogin: false,
                });
            });
    };

    public checkStoreURL = (): void => {
        if(window && window.location) {
            const split = window.location.host.split(".");

            if(split.length === 3) {
                this.setState({
                    store    : split[0],
                    showStore: false,
                });
            } else {
                const previousUrl = getCookie("last_login_domain");

                if(typeof previousUrl === "string") {
                    this.setState({
                        store: previousUrl,
                    });
                }
            }
        }
    };

    public render(): React.ReactNode {
        let loginText = (
            <React.Fragment>
                <FontAwesomeLight icon="sign-in" />Login
            </React.Fragment>
        );

        if(this.state.loadingLogin) {
            loginText = <FontAwesomeLight icon="spinner-third" spin />;
        }

        return (
            <div id="login-box" className="type">
                <div id="login-form">
                    <div className="login-form">
                        <LoginForm
                            store={this.state.store}
                            username={this.state.username}
                            password={this.state.password}
                            onStoreChange={this.handleStoreChange}
                            onUsernameChange={this.handleUsernameChange}
                            onPasswordChange={this.handlePasswordChange}
                            onLogin={this.handleLogin}
                            showStore={this.state.showStore}
                            disabled={this.state.loadingLogin}
                        />
                        <div id="login-actions">
                            <PrimaryButton
                                onClick={this.handleLogin}
                                data-testid="gl-login-button"
                            >
                                {loginText}
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
                <div id="login-news">
                    <LoginNews />
                </div>
            </div>
        );
    }
}
